export default {"src":"/_next/static/media/bundle-promo-hero.901f0bc1.svg","height":154,"width":300,"blurWidth":0,"blurHeight":0};